module.exports = __webpack_public_path__ + "components/about-header/static/header--medium-a35a3626fb3d5cf40b5dcd9c70be027a.jpg";